import React, { useEffect, useState } from 'react';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';
import { getOrganizationPropertiesByHost } from '../../utils/helpers';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const { miscellaneousData } = useMiscellaneousData();
  const domainName = getOrganizationPropertiesByHost(miscellaneousData.hostname);
  const isNextIas = domainName.organizationName === 'nextias';

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Commented out automatic scroll to top on route change
  // This is now handled by NavigationProvider which preserves scroll position
  // useEffect(() => {
  //   const handleRouteChange = () => {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //   };

  //   router.events.on('routeChangeComplete', handleRouteChange);

  //   return () => {
  //     router.events.off('routeChangeComplete', handleRouteChange);
  //   };
  // }, [router]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed ${isNextIas ? 'bottom-48 md:bottom-28 h-10 w-10' : 'bottom-48 md:bottom-16 h-9 w-9'} right-2 z-[9999] flex items-center justify-center rounded-full bg-white shadow-lg`}
    >
      {
         isNextIas ? (
           <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
             <circle cx="32" cy="32" r="29" stroke="#FF2D2D" strokeWidth="2" />
             <path
               d="M32 44V22M32 22L24 30M32 22L40 30"
               stroke="#FF2D2D"
               strokeWidth="2"
               strokeLinecap="round"
               strokeLinejoin="round"
             />
           </svg>
         )
           : (
             <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
               <circle cx="32" cy="32" r="31" stroke="#FFFFFF" strokeWidth="2" />
               <circle cx="32" cy="32" r="29" fill="#0A66C2" />
               <rect x="30.75" y="26" width="2.5" height="16" fill="#FFFFFF" />
               <path d="M32 18L24 28H40L32 18Z" fill="#FFFFFF" />
             </svg>
           )
        }
    </button>
  );
}
